import {
  markdownToPreview,
  markdownToPreviewInline,
} from '@components/designer/utils/markdownToPreview';
import type { KnowledgeArticleDTO } from '@conversed/rest/src/contracts/article-architect/article-architect.dto';
import type { KnowledgeArticleStatus } from '@conversed/rest/src/contracts/article-architect/article-architect.enums';
import { purify } from '@helpers/domHelper';
import parse from 'html-react-parser';

export const parseArticleMarkdown = (body: string): ReturnType<typeof parse> =>
  parse(purify(markdownToPreview(body), 'markdown-link-inherit'));

// For short snippets rendered inside an existing paragraph - the conflict judge's
// evidence quotes. The block renderer would emit a <p>, which cannot legally nest
// inside the quote's own <p>.
//
// The <span> wrapper is load-bearing: `purify` runs DOMPurify with FORCE_BODY: false,
// which silently drops a leading bare text node ("valid for **24h**" would render as
// just "24h"). Block-rendered markdown always starts with a tag, so this never
// surfaced there. Wrapping gives the sanitiser an element to start from.
export const parseArticleMarkdownInline = (
  text: string,
): ReturnType<typeof parse> =>
  parse(
    purify(
      `<span>${markdownToPreviewInline(text)}</span>`,
      'markdown-link-inherit',
    ),
  );

export const filterArticlesByStatus = (
  articles: KnowledgeArticleDTO[],
  status: KnowledgeArticleStatus,
): KnowledgeArticleDTO[] =>
  articles.filter((article) => article.status === status);
